export default {"src":"/_next/static/media/facebook-icon.769e7339.svg","height":96,"width":45};